<template>
    <div class="full-height">
        <header class="" id="header-main">
            <nav class="navbar navbar-main navbar-expand-lg shadow navbar-light" id="navbar-main">
                <div class="container-fluid">
                    <button @click="showNavbar = !showNavbar"
                            class="navbar-toggler order-lg-2 ml-n3 ml-lg-0"
                            type="button"
                    >
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <a href="https://302uitvaart.nl?utm_source=2go&utm_medium=logo" target="_blank">
                        <img :src="companyLogo" style="height: 50px;" />
                    </a>

                    <div class="collapse navbar-collapse navbar-collapse-overlay" id="navbar-main-collapse" :class="showNavbar ? 'show' : ''">
                        <div class="position-relative">
                            <button @click="showNavbar = !showNavbar"
                                    class="navbar-toggler"
                                    type="button"
                            >
                                <XIcon />
                            </button>
                        </div>

                        <ul class="navbar-nav w-100 mr-3 ml-3">
                            <li class="nav-item nav-item-spaced ml-lg-auto" v-if="hasPermission('viewCeremonies')">
                                <router-link class="nav-link" :to="{ name: 'ceremonies' }">
                                    {{ $t('designer.ceremonies') }}
                                </router-link>
                            </li>

                            <li class="nav-item nav-item-spaced dropdown dropdown-animate" data-toggle="hover" v-if="hasAnyPermissions(['manageSongs', 'manageUsers'])">
                                <a class="nav-link" href="#" role="button">{{ $t('designer.manage') }}</a>
                                <div class="dropdown-menu dropdown-menu-md p-0">
                                    <ul class="list-group list-group-flush">
                                        <li v-if="hasPermission('manageSongs')">
                                            <router-link :to="{ name: 'music-library' }" tag="a" class="list-group-item list-group-item-action" role="button">
                                                <div class="d-flex">
                                                    <div class="ml-3">
                                                        <h6 class="heading mb-0">{{ $t('songs.library_title') }}</h6>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>

                                        <li v-if="hasPermission('manageUsers')">
                                            <router-link :to="{ name: 'users' }" tag="a" class="list-group-item list-group-item-action" role="button">
                                                <div class="d-flex">
                                                    <div class="ml-3">
                                                        <h6 class="heading mb-0">{{ $t('designer.manage_users') }}</h6>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>

                                        <li v-if="hasPermission('manageEmailTemplates')">
                                            <router-link :to="{ name: 'email-templates' }" tag="a" class="list-group-item list-group-item-action" role="button">
                                                <div class="d-flex">
                                                    <div class="ml-3">
                                                        <h6 class="heading mb-0">{{ $t('designer.email_templates') }}</h6>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>

                                        <li v-if="hasPermission('manageCorporateStyle')">
                                            <router-link :to="{ name: 'corporate-style' }" tag="a" class="list-group-item list-group-item-action" role="button">
                                                <div class="d-flex">
                                                    <div class="ml-3">
                                                        <h6 class="heading mb-0">{{ $t('designer.corporate_style') }}</h6>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="ml-auto nav-item nav-item-spaced d-flex align-items-center mr-2" v-tooltip="$t('general.help')">
                                <a
                                    href="https://302uitvaart.nl/help?utm_source=2go&utm_medium=menu&utm_id=help"
                                    target="_blank"
                                    class="btn btn-company-yellow btn-icon btn-sm rounded-pill"
                                >
                                    <Icon name="question" scale="1" class="mr-0" />
                                </a>
                            </li>

                            <li class="ml-lg-2 nav-item nav-item-spaced d-flex align-items-center">
                                <LanguageSwitcher />
                            </li>

                            <UserNavigationItem v-if="user" :user="user" @logout="logout" class="ml-lg-4" />
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <div class="container-fluid full-height">
            <div class="row full-height">
                <div class="col-12 full-height">
                    <slot />
                </div>
            </div>
        </div>

        <span class="app-version">{{ $t('ceremony.version', { version: appVersion }) }}</span>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import { XIcon } from 'vue-feather-icons';
    import LanguageSwitcher from '../../components/LanguageSwitcher.vue';
    import Icon from 'vue-awesome/components/Icon';
    import UserNavigationItem from '../../components/UserNavigationItem.vue';
    import { IpcCall, ipcCall } from '../utils/ipcCall';

    export default {
        components: {
            UserNavigationItem,
            LanguageSwitcher,
            XIcon,
            Icon,
        },

        computed: {
            ...mapState({
                user: state => state.user,
            }),

            ...mapGetters([
                'hasPermission',
                'hasAnyPermissions',
            ]),

            companyLogo() {
                // Bust the cache, we may need some better logics for this because this will reload on every page navigation.
                // It does not network requests, it only loads the file from filesystem.
                return 'company-asset://logo.png?v=' + (new Date()).getTime();
            },
        },

        data() {
            return {
                showNavbar: false,
                appVersion: APP_VERSION,
            };
        },

        methods: {
            async logout() {
                await ipcCall(IpcCall.Logout);

                await this.$store.dispatch('logout');
                await this.$router.push('/login');
            },
        },
    };
</script>

<style lang="scss" scoped>

    .app-version {
        font-size: 12px;
        pointer-events: none;
        position: fixed;
        bottom: 5px;
        left: 5px;
    }

</style>
